module.exports = __webpack_public_path__ + "img/ondivan_marca_red.077d0a36.svg";